import styled from 'styled-components'
import { Tabs } from 'react-bootstrap'

export const Container = styled(Tabs)`
  .nav-link {
    color: ${props => props.theme.colors.textPrimary};
  }
`
